import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatTooltipModule } from '@angular/material/tooltip';

import { MaterialModule } from "./material.module";
import { FeatherIconsModule } from "./components/feather-icons/feather-icons.module";
import { RequiredBorderDirective } from "../directives/required-border/required-border.directive";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { NgxPaginationModule } from "ngx-pagination";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { BrowserModule } from "@angular/platform-browser";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatRadioModule } from "@angular/material/radio";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { AppImgFallbackDirective } from "../directives/appImgFallback/app-img-fallback.directive";
import { BackgroundImgDirective } from "../directives/background-img/background-img.directive";
import { CustomDeletePopoverComponent } from "../pages/custom-delete-popover/custom-delete-popover.component";
import { TruncatePipe } from "../pipes/truncate/truncate.pipe";
import { LayoutModule } from "../layout/layout.module";
import { ComponentsModule } from "./components/components.module";
import { SanitizeHtmlPipe } from "../pipes/sanitize-html/sanitize-html.pipe";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { FilterComponent } from "../pages/filter/filter.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { NgxPermissionsModule } from "ngx-permissions";
import { SafePipe } from "../pipes/safe.pipe";
import { SDatePipe } from "../pipes/date/date.pipe";
import { LoadingSpinnerComponent } from "../pages/loading-spinner/loading-spinner.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { MatSelectModule } from "@angular/material/select";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MY_FORMATS } from "../model/date_format";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatStepperModule } from '@angular/material/stepper';
// import { TruncatePipe } from "../pipes/truncate/truncate.pipe";
// import { BackgroundImgDirective } from "../directives/background-img/background-img.directive";
@NgModule({
  declarations: [
    // AppImgFallbackDirective,
    RequiredBorderDirective,
    BackgroundImgDirective,
    CustomDeletePopoverComponent,
    LoadingSpinnerComponent,
    // TruncatePipe, 
    TruncatePipe,
    SanitizeHtmlPipe,
    FilterComponent,
    SafePipe,
    SDatePipe
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbPaginationModule, MatDatepickerModule, NgxPermissionsModule, NgxSpinnerModule, MatSelectModule,
    NgScrollbarModule,   NgSelectModule,
  ],
  //Note: always export the module/component/pipes/directive etc which you want to use out of the scope of this module as the one declared in declaration 
  //let us to use them in same modules only and not in other part of the app.
  exports: [
    BackgroundImgDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    FeatherIconsModule,
    RequiredBorderDirective,
    MatCheckboxModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSortModule,
    NgxPaginationModule,
    MatTableModule,
    MatButtonModule,
    MatExpansionModule,
    MatRadioModule,
    DragDropModule,
    TranslateModule,
    CustomDeletePopoverComponent,
    TruncatePipe,
    SanitizeHtmlPipe,
    FilterComponent,
    SafePipe,
    SDatePipe,
    LoadingSpinnerComponent,
    MatSelectModule,
    MatStepperModule,
    MatStepperModule,
    MatTooltipModule
  ],
  providers: [DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },], // 
})
export class SharedModule { }
